<h2 class="mt-3 mb-4">Invite Users</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">Failed to send invitations<br>{{ error?.description }}</div>
</div>
<div class="notice" *ngIf="success">
  <div class="notice-body">Invitation{{ sentCount === 1 ? '' : 's' }} sent</div>
</div>

<form [formGroup]="InviteUsersForm" class="invite-users-form">
  <mat-form-field appearance="fill" class="invite-contract-field">
    <mat-label>Contract/Agreement No</mat-label>
    <mat-select id="inviteContractNo" formControlName="contractNo">
      <mat-option *ngFor="let contract of shellService.contracts" [value]="contract.id">
        {{ contract.id }} - {{ contract.displayName || contract.product }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div formArrayName="emails" class="invite-email-list">
    <div class="invite-email-row" *ngFor="let email of emails.controls; let i = index">
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput [id]="'inviteEmail' + i" type="email" [formControlName]="i" />
      </mat-form-field>
      <button mat-icon-button type="button" [id]="'remove-invite-email-' + i" (click)="removeEmail(i)" matTooltip="Remove email">
        <mat-icon>remove</mat-icon>
      </button>
    </div>
  </div>

  <div class="invite-actions">
    <button mat-stroked-button color="primary" id="add-invite-email-button" type="button" (click)="addEmail()">
      <mat-icon>add</mat-icon>
      Add user
    </button>
    <button mat-flat-button color="primary" id="invite-users-button" type="button" (click)="inviteUsers()"
      [disabled]="inviteDisabled()">
      <mat-spinner *ngIf="inviting" diameter="20" mode="indeterminate"></mat-spinner>
      {{ inviting ? 'Sending' : 'Send Invitations' }}
    </button>
  </div>
</form>

<section class="pending-invites">
  <div class="pending-invites-header">
    <h3>Pending Invitations</h3>
    <button mat-icon-button type="button" id="refresh-invites-button" (click)="loadInvites()" matTooltip="Refresh invitations">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div class="table-loading-state" *ngIf="loadingInvites">
    <mat-spinner diameter="28" mode="indeterminate"></mat-spinner>
  </div>

  <div class="invite-list" *ngIf="!loadingInvites">
    <div class="invite-empty" *ngIf="invites.length === 0">No pending invitations.</div>
    <div class="invite-list-row invite-list-heading" *ngIf="invites.length > 0">
      <span>Email</span>
      <span>Expires</span>
      <span>Status</span>
      <span></span>
    </div>
    <div class="invite-list-row" *ngFor="let invite of invites">
      <span class="invite-email" [matTooltip]="invite.email">{{ invite.email }}</span>
      <span>{{ invite.expires | date: "dd MMMM yyyy" }}</span>
      <span>{{ invite.expired ? 'Expired' : 'Pending' }}</span>
      <span class="invite-row-actions">
        <button mat-icon-button color="primary" type="button" *ngIf="invite.expired" (click)="resendInvite(invite)"
          [disabled]="inviteActionDisabled(invite)" matTooltip="Resend invitation">
          <mat-icon>send</mat-icon>
        </button>
        <button mat-icon-button color="warn" type="button" (click)="deleteInvite(invite)"
          [disabled]="inviteActionDisabled(invite)" matTooltip="Delete invitation">
          <mat-icon>delete</mat-icon>
        </button>
      </span>
    </div>
  </div>
</section>
